import { BrowseGalleryRounded, OpenInNewRounded } from "@mui/icons-material";

import { Button } from "@fragments";
import Parser from "@helpers/parser";
import { useAuth } from "@contexts/AuthContext";
import { useCommunity } from "@contexts/CommunityContext";

/** Badge sutil para administradores visualizando conteúdo pré-lançamento. */
export function AdminPreviewBadge({ launchDate }) {
    return (
        <div className="admin-preview-badge">
            <BrowseGalleryRounded fontSize="small" />
            <span>Vai ao ar em {Parser.date.readable(launchDate)}</span>
        </div>
    );
}

/** Banner para conteúdo agendado (usuário não tem acesso mas vai ser lançado). */
export function LaunchDateBanner({ content }) {
    const displayDate = content.timestamps?.launch || content.availability?.available_at;

    return (
        <>
            <img src={content.banner} alt={content.name} className="content-banner" />
            <div className="launch-date-card">
                <BrowseGalleryRounded fontSize="medium" />
                <span>Vai ao ar no dia {Parser.date.readable(displayDate)}</span>
            </div>
        </>
    );
}

/** Paywall para conteúdo premium indisponível ao usuário atual. */
export function PrivateVideoBanner({ community, content }) {
    const { community: currentCommunity } = useCommunity();
    const { user } = useAuth();

    const currentCommunityInfo = currentCommunity?.get(community);

    if (!currentCommunityInfo || !content) return null;

    const planWhichIsAvailable = currentCommunityInfo?.plans?.find(
        (p) => p.id == content.availability?.plans?.[0]
    );

    let checkoutLink = `https://pay.ginastee.com/${currentCommunityInfo?.checkout}?email=${user.email.address}&name=${user.username}`;

    if (planWhichIsAvailable) {
        checkoutLink += `&plan=${planWhichIsAvailable?.id}`;
    }

    if (user.phone?.number) {
        checkoutLink += `&phone=${user.phone.number?.replace("+55", "")}`;
    }

    if (user.document) {
        checkoutLink += `&document=${user.document}`;
    }

    return (
        <>
            <img src={content.banner} alt={content.name} className="content-banner" />

            <div className="request-upgrade-banner px-4 py-4">
                <small className="premium-message-text">Desbloqueie este recurso premium assinando a comunidade</small>
                <img src={currentCommunityInfo?.banner} alt={currentCommunityInfo?.name} className="community-banner mt-2" />
                <h4 className="mb-1">{currentCommunityInfo?.name}</h4>
                <Button
                    text="Ver planos"
                    color="white"
                    tooltip={"Ver planos da comunidade " + currentCommunityInfo?.name}
                    startIcon={<OpenInNewRounded />}
                    onClick={() => (window.location.href = checkoutLink)}
                />
            </div>
        </>
    );
}
